import type {
  DeleteSnapQuoteLineAttachmentOutput,
  DeleteSnapQuoteLineAttachmentRequest,
} from '@snap-types/actions/delete-snap-quote-line-attachment';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildSnapQuoteUrl } from '@ui/store/api-builder/build-url';
import { injectMutation } from '@ui/store/api-builder/inject-mutation';

export const [
  deleteSnapQuoteLineAttachment,
  useDeleteSnapQuoteLineAttachmentMutation,
] = injectMutation<
  DeleteSnapQuoteLineAttachmentRequest,
  DeleteSnapQuoteLineAttachmentOutput
>(
  `${QUOTE_BUILDER_SLICE_NAME}/deleteSnapQuoteLineAttachment`,
  ({ params }) => ({
    url: buildSnapQuoteUrl(
      params.siteCode,
      params.snapQuoteUuid,
      `quote-lines/${params.snapQuoteLineUuid}/attachments/${params.attachmentUuid}`,
    ),
    method: 'DELETE',
  }),
);
